// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3400":"11c5a680","9359":"aa77a913"}[chunkId] + ".chunk.css";
};